export function CuriosityTrigger() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/168da6baeefa78f178342e1e214bd1d5.jpg')`
        }}
      ></div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            What Would Your Business Look Like<br />With a Modern Website?
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {[
            {
              icon: 'ri-user-add-line',
              title: 'More Leads',
              desc: 'Consistent flow of qualified inquiries from customers actively searching for your services'
            },
            {
              icon: 'ri-line-chart-line',
              title: 'Higher Visibility',
              desc: 'Appear at the top of search results when potential customers look for businesses like yours'
            },
            {
              icon: 'ri-trophy-line',
              title: 'Stronger Brand',
              desc: 'Professional online presence that builds trust and positions you above competitors'
            }
          ].map((item, index) => (
            <div key={index} className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all">
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <i className={`${item.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-center">{item.title}</h3>
              <p className="text-gray-300 text-center text-sm">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-500/20 to-cyan-500/20 backdrop-blur-sm rounded-2xl p-8 border border-teal-500/30 mb-8">
          <p className="text-2xl font-bold text-center mb-4">
            Many businesses see dramatic improvement when they upgrade their website structure and visibility strategy.
          </p>
          <p className="text-xl text-gray-300 text-center">
            The difference between being invisible online and being the obvious choice in your market.
          </p>
        </div>

        <div className="text-center">
          <button 
            onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-10 py-5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-xl font-bold text-xl hover:from-teal-600 hover:to-cyan-600 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
          >
            Explore Your Opportunity
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}